module.exports = __webpack_public_path__ + "img/raw.2958566d.png";